import React from 'react';
import ReactDOM from 'react-dom';
import Root from './containers/Root';
import { BrowserRouter as Router } from 'react-router-dom';
import PageLoader from './components/elements/loaders/PageLoader';
import store from './store';

class AppWithPageLoader extends React.Component {
  state = { loaded: false, loaderRemoved: false };

  componentDidMount() {
    const hideLoader = () => {
      this.setState({ loaded: true });
      setTimeout(() => this.setState({ loaderRemoved: true }), 500);
    };
    // Hide after first paint so the page and image skeletons are visible;
    // do not wait for window 'load' (images, etc.)
    requestAnimationFrame(() => requestAnimationFrame(hideLoader));
  }

  render() {
    const { loaded, loaderRemoved } = this.state;
    return (
      <>
        {!loaderRemoved && (
          <PageLoader isVisible={!loaded} isHiding={loaded} />
        )}
        <Router>
          <Root store={store} />
        </Router>
      </>
    );
  }
}

ReactDOM.render(
    <React.StrictMode>
      <AppWithPageLoader />
    </React.StrictMode>,
    document.getElementById('root')
);
